<template>
    <div>
        <div class="text-center max-w-400 mx-auto font-semibold">
            {{ $t('campaigns.editor.payment.warning') }}
        </div>
        <simple-button display="primary" class="mx-auto mt-8" @click="save" :disabled="saving">
            {{ $t('campaigns.editor.payment.button') }}
        </simple-button>
    </div>
</template>

<script>
import SimpleButton from "../SimpleButton";
import Form from "../../../etc/forms/Form";

export default {
    components: {SimpleButton},
    props: {
        saving: Boolean
    },
    data() {
        return {
            form: new Form([
                { name: 'step', value: 'end' },
                { name: 'status', value: 'open' }
            ])
        }
    },
    methods: {
        save() {
            this.$emit('save', {
                form: this.form,
                todo: 'close'
            });
        },
    }
}
</script>
